module.exports = __webpack_public_path__ + "static/media/14_potolok_8.33_0.7e5ab460.png";